import { useState, useEffect, useContext } from "react";
import { Link, NavLink, useParams } from "react-router-dom";
import axios from "axios";
import { ConfigContext } from "../../Context/ConfigContext";
import AccountSiderBar from "./AccountSideBar";
import { useTranslation } from 'react-i18next';
import { toast } from "react-toastify";
import QRCode from 'qrcode';
import 'jspdf-autotable';
import { OverlayLoader } from "../../Components/Shimmers";
import Swal from "sweetalert2";
import CancelStatusCard from "../../Components/OrdersComponent/CancelStatusCard";
import { GetOrdersStatus } from "../../Utils/Cities";
import Config from "../../appConfig";
import { axiosGet, axiosPost } from "../../Apis/axiosMethods";

const OrderDetails = () => {

  const { token, lang, apiB2BURL, currency, apiHeaderJson } = useContext(ConfigContext);
  const headers = apiHeaderJson;

  const { order_uid } = useParams();
  const [orderInfo, setOrderInfo] = useState([]);
  const [address, setAddress] = useState([]);
  const [details, setDetails] = useState([]);
  const [items, setItems] = useState([]);
  const { t } = useTranslation();
  const dir = localStorage.getItem('dir');
  const [qrCodeURL, setQrCodeURL] = useState('');
  const [showReturnModal, setShowReturnModal] = useState(false);
  const [returnItem, setReturnItem] = useState(null);
  const [returnQuantity, setReturnQuantity] = useState('');
  const [returnReason, setReturnReason] = useState('');
  const [submitting, setSubmitting] = useState(false);

  const [returnData, setReturnData] = useState([]);
  const [cancelData, setCancelData] = useState([]);
  const [openReturnHistory, setOpenReturnHistory] = useState({});
  const [openCancelHistory, setOpenCancelHistory] = useState({});

  const [loading, setLoading] = useState(true);

  useEffect(() => {
    QRCode.toDataURL('https://ghayar.com')
      .then(url => {
        setQrCodeURL(url);
      })
      .catch(err => {
        console.error(err)
      })

  }, [])

  useEffect(() => {
    OrderInfo();
  }, [])

  const OrderInfo = async () => {
    try {
      setLoading(true);

      const business_id = localStorage.getItem("business_id");
      const business_user_id = localStorage.getItem("business_user_id");

      const { data } = await axiosGet(`/Orders/GetGroupByOrdersDetails`, {
        business_id,
        business_user_id,
        lang,
        secret_order_id: order_uid,
        currency
      });
      if (data?.success) {

        setOrderInfo(data.data);
        setDetails(data.data);
        setItems(data.items);
        setAddress(data.address);
        setReturnData(data.return_data || []);
        setCancelData(data.cancel_data || []);
      }

    } catch (error) {
      console.error("Error:", error);

      if (error.response) {
        console.error("Response Error:", error.response.data);
      } else if (error.request) {
        console.error("Request Error:", error.request);
      } else {
        console.error("Message:", error.message);
      }
    } finally {
      setLoading(false);
    }
  };


  const getItemReturns = (itemId) => {
    return returnData?.filter(
      (ret) => Number(ret.business_return_order_item_id) === Number(itemId)
    ) || [];
  };

  const getItemCancels = (itemId) => {
    return cancelData?.filter(
      (cancel) => Number(cancel.business_order_item_id) === Number(itemId)
    ) || [];
  };

  const getTotalCancelledQty = (itemId) => {
    return getItemCancels(itemId)
      .filter((cancel) => Number(cancel.business_order_cancel_status) === 1)
      .reduce((sum, cancel) => {
        return sum + Number(cancel.business_order_cancel_item_qty || 0);
      }, 0);
  };

  const getTotalReturnedQtyModal = (itemId) => {
    return getItemReturns(itemId)
      .filter(
        (ret) => Number(ret.business_return_status) !== 4)
      .reduce((sum, ret) => {
        return sum + Number(ret.business_return_qty || 0);
      }, 0);
  };

  const getTotalReturnedQty = (itemId) => {

    return getItemReturns(itemId)
      .filter(
        (ret) => Number(ret.business_return_status) === 3
      )
      .reduce((sum, ret) => {

        return sum + Number(ret.business_return_qty || 0);

      }, 0);
  };

  const toggleReturnHistory = (itemId) => {
    setOpenReturnHistory((prev) => ({
      ...prev,
      [itemId]: !prev[itemId]
    }));
  };

  const toggleCancelHistory = (itemId) => {
    setOpenCancelHistory((prev) => ({
      ...prev,
      [itemId]: !prev[itemId]
    }));
  };

  const openReturnModal = (item) => {
    const totalReturnedQty = getTotalReturnedQtyModal(item.item_id);
    const orderedQty = Number(item.item_qty);

    const maxReturnableQty = orderedQty - totalReturnedQty;

    if (maxReturnableQty <= 0) {
      toast.error("You have already requested return for full quantity.");
      return;
    }

    setReturnItem({
      ...item,
      maxReturnableQty
    });

    setReturnQuantity(1);
    setReturnReason('');
    setShowReturnModal(true);
  };

  const closeReturnModal = () => {
    setShowReturnModal(false);
  };

  const handleRequestReturn = async () => {
    try {
      if (!returnQuantity || parseInt(returnQuantity) < 1) {
        toast.error("Please enter a valid return quantity.");
        return;
      }
      if (!returnReason || returnReason.trim() === "") {
        toast.error("Please provide a reason for return.");
        return;
      }

      const maxAllowed = returnItem.maxReturnableQty;

      if (parseInt(returnQuantity) > maxAllowed) {
        toast.error(`Maximum returnable quantity is ${maxAllowed}.`);
        return;
      }

      setSubmitting(true);
      const business_id = localStorage.getItem("business_id");
      const business_user_id = localStorage.getItem("business_user_id");
      const headers = {
        token: token,
        businessid: String(business_id),
        businessuserid: String(business_user_id),
        Accept: "application/json",
        "Content-Type": "application/json"
      };

      const payload = {
        order_id: orderInfo?.business_order_id,
        business_id: orderInfo.business_id,
        order_item_id: returnItem.item_id,
        return_quantity: returnQuantity,
        return_reason: returnReason,
        business_return_item_store_id: orderInfo?.business_order_item_store_id,
        invoice_id: returnItem?.invoice_id
      };

      const response = await axiosPost(`/Orders/ReturnRequest`, payload);

      if (response.data.success) {
        OrderInfo();
        toast.success("Return request submitted successfully.");
        closeReturnModal();
      } else {
        toast.error("Failed to submit return request.");
      }
    } catch (error) {
      console.error("Error requesting return:", error);
      toast.error("Error requesting return.");
    } finally {
      setSubmitting(false);
    }
  };

  const increaseQty = () => {
    if (!returnItem) return;

    const alreadyReturned = getTotalReturnedQty(returnItem.item_id);
    const orderedQty = Number(returnItem.item_qty);
    const maxAllowed = orderedQty - alreadyReturned;

    if (parseInt(returnQuantity) < maxAllowed) {
      setReturnQuantity(String(parseInt(returnQuantity) + 1));
    }
  };

  const decreaseQty = () => {
    if (parseInt(returnQuantity) > 1) {
      setReturnQuantity(String(parseInt(returnQuantity) - 1));
    }
  };

  const handleCancelItem = async (item) => {
    try {
      const { value: cancelRemark } = await Swal.fire({
        title: 'Cancel Order Item',
        width: 400,
        html: `
        <div style="text-align:left;width:100%;overflow:hidden;box-sizing:border-box;margin-top:10px;">
          <p style="margin-bottom:8px;word-break:break-word;"><b>Item :</b> ${item.item_name}</p>
          <p style="margin-bottom:12px;word-break:break-word;"><b>Part No :</b> ${item.item_number}</p>

          <textarea 
            id="cancelRemark"
            placeholder="Enter cancellation remark..."
            style="
              width:100%;
              min-height:100px;
              padding:10px;
              border:1px solid #dcdcdc;
              border-radius:8px;
              resize:none;
              box-sizing:border-box;
              margin:0;
              outline:none;
              font-size:14px;
              font-family:inherit;
            "
          ></textarea>
        </div>
      `,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Submit Cancel',
        cancelButtonText: 'Close',
        focusConfirm: false,
        preConfirm: () => {
          const remark = document.getElementById("cancelRemark").value;

          if (!remark || remark.trim() === "") {
            Swal.showValidationMessage("Please enter cancellation remark");
            return false;
          }

          return remark;
        }
      });

      if (!cancelRemark) return;

      Swal.fire({
        title: "Submitting...",
        text: "Please wait while cancelling item",
        allowOutsideClick: false,
        didOpen: () => {
          Swal.showLoading();
        }
      });

      const business_id = localStorage.getItem("business_id");
      const business_user_id = localStorage.getItem("business_user_id");

      const payload = {
        business_order_id: orderInfo?.business_order_id,
        business_id: business_id,
        business_order_cancel_remark: cancelRemark,
        business_order_cancel_amount: item?.item_sub_total,
        business_order_item_id: item?.item_id,
        business_order_cancel_item_name: item?.item_name,
        business_order_cancel_item_number: item?.item_number,
        business_order_cancel_item_brand_name: item?.item_brand,
        business_order_cancel_item_sup_id: item?.business_order_item_sup_id,
        business_order_cancel_item_qty: item?.item_qty,
        business_order_cancel_item_price: item?.item_price,
        business_order_cancel_item_sub_total: item?.item_sub_total,
        business_order_cancel_item_store_id: item?.business_order_item_store_id,
        business_order_cancel_item_stock_oe: item?.stock_oe
      };

      const response = await axiosPost(`/Orders/CancelOrderItem`, payload);

      Swal.close();

      if (response.data.success) {
        await Swal.fire({
          icon: "success",
          title: "Success!",
          text: "Cancellation request submitted successfully."
        });

        OrderInfo();
      } else {
        Swal.fire({
          icon: "error",
          title: "Failed",
          text: response.data.message || "Failed to cancel item."
        });
      }

    } catch (error) {
      console.log("Cancel Item Error:", error);

      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Something went wrong while cancelling item."
      });
    }
  };

  return (
    <>
      {
        loading ?
          <div style={{ height: "70vh" }}>
            <OverlayLoader />
          </div>
          :
          <main>
            <div className="page-header">
              <div className="container d-flex flex-column align-items-center">
                <nav aria-label="breadcrumb" className="breadcrumb-nav">
                  <div className="container">
                    <ol className="breadcrumb" dir={dir}>
                      <li className="breadcrumb-item">
                        <NavLink to={"/"}>{t("home")}</NavLink>
                      </li>
                      <li className="breadcrumb-item">
                        <NavLink to={`/MyAccount`}>{t("my_account")}</NavLink>
                      </li>
                      <li className="breadcrumb-item">
                        <NavLink to={`/MyAccount/Orders`}>{t("orders")}</NavLink>
                      </li>
                      <li className="breadcrumb-item active" aria-current="page">
                        {t("order_details")}
                      </li>
                    </ol>
                  </div>
                </nav>
                <h1>{t("order_details")}</h1>
              </div>
            </div>
            <div className="container account-container custom-account-container" dir={dir}>
              <div className="row justify-content-center">
                <AccountSiderBar />
                <div className="col-lg-10 order-lg-last order-1 tab-content">
                  <div
                    className="tab-pane fade show active"
                    id="address"
                    role="tabpanel">
                    <div className="order-content">
                      <div className="row">
                        <div className="col-md-6">
                          <h3 className="account-sub-title d-none d-md-block">
                            <i className="sicon-social-dropbox align-middle mr-3" />

                            {t("order_number", { value: ":" + order_uid })}
                          </h3>
                        </div>
                        <div className="col-md-6 align-bottom d-flex justify-content-end">
                          {
                            orderInfo?.business_order_status === 6 ? (
                              <div
                                style={{
                                  paddingTop: '10px',
                                  color: '#dc3545',
                                  fontWeight: '600',
                                  fontSize: '14px'
                                }}
                              >
                                <i className="fa fa-ban mr-1"></i> This order has been fully cancelled
                              </div>
                            ) : orderInfo?.business_order_status === 7 ? (
                              <div
                                style={{
                                  paddingTop: '10px',
                                  color: '#198754',
                                  fontWeight: '600',
                                  fontSize: '14px'
                                }}
                              >
                                <i className="fa fa-undo mr-1"></i> This order has been fully returned
                              </div>
                            ) : (
                              <div className="d-flex justify-content-end" style={{ paddingTop: '10px' }}>
                                <NavLink to={`/MyAccount/Orders/Download/${order_uid}`}>
                                  <span style={{ cursor: 'pointer' }} className="nav-link">
                                    <i className="sicon-cloud-download"></i> Download Order Details
                                  </span>
                                </NavLink>

                                <NavLink to={`/MyAccount/Orders/Print/${order_uid}`}>
                                  <span style={{ cursor: 'pointer' }} className="nav-link">
                                    <i className="sicon-printer"></i> Print Order Details
                                  </span>
                                </NavLink>
                              </div>
                            )
                          }
                        </div>
                      </div>

                      <div className="order-table-container text-center">
                        <div className="order-summary">
                          <table>
                            <tr>
                              <td
                                className="text-left align-top"
                                style={{ width: "40%" }}>
                                <h5>{t("shipping_address")}</h5>
                                <b>
                                  {address.business_address_title}
                                </b>
                                <p
                                  className="xw-50"
                                  style={{ fontFamily: "arial" }}>
                                  <i>
                                    {" "}
                                    {address.business_full_address} <br />
                                    {address.business_city} <br />

                                    {address.mobile_number_1} <br />{" "}
                                    {address.contact_email}{" "} , <br />
                                    TRN : {details.busienss_trn}
                                  </i>
                                </p>
                                {
                                  details?.business_order_ref_client &&
                                  <p>Ref Client : {details?.business_order_ref_client}</p>
                                }
                              </td>
                              <td
                                className="text-left align-top"
                                style={{ width: "30%", textTransform: 'uppercase', textAlign: 'center' }}>
                                <h5>{t("payment_method")}</h5>
                                {details.business_order_payment_method === "cod" ? (
                                  <b>Cash on Delivery</b>

                                ) : (
                                  <b>{details.business_order_payment_method}</b>
                                )}


                                <img src={qrCodeURL} alt="QR Code" />
                              </td>
                              <td
                                className="text-left align-top"
                                style={{ width: "40%" }}>
                                <div className="align-right">
                                  <h5>{t("order_summary")}</h5>
                                  <table>
                                    {
                                      details.business_order_payment_method === 'cod' && details.cod_applicable === 1 && <tr> <td>{t("shipping_charges")}</td> <th>: {details.display_cod_charges}</th> </tr>
                                    }
                                    {
                                      details?.business_order_total_saving > 0 &&
                                      <tr> <td>{t("Discount")}</td> <th>: {details.business_order_total_saving && <span>{details.business_order_total_saving ? details.business_order_total_saving : '00.0'}</span>} {Config.currency}</th> </tr>
                                    }
                                    <tr> <td>{t("Taxable Amount")}</td> <th>: {details?.business_order_sub_total && <span>{details?.grand_total_excl_vat}</span>}</th> </tr>
                                    <tr> <td>{t("VAT 5%")}</td> <th>: {details?.business_order_vat_amount && <span>{details?.grand_total_vat_amount}</span>}</th> </tr>
                                    <tr>
                                      <td>{t("grand_total")}</td>
                                      <th>: {details.grand_total_incl_vat}</th>
                                    </tr>
                                  </table>
                                </div>
                              </td>
                            </tr>
                          </table>
                        </div>
                        <div className="order-summary">
                          <table className="table table-cart">
                            <thead>
                              <tr>

                                <th style={{ textAlign: "left" }}>{t(`product`)}</th>
                                <th className="qty-col">Brand Name</th>
                                <th className="qty-col">{t(`quantity`)}</th>
                                <th className="price-col">{t(`price`)}</th>
                                <th className="qty-col">{t(`VAT`)}</th>
                                <th className="text-right">{t(`Total`)}</th>
                                <th className="text-right">Item Status</th>
                              </tr>
                            </thead>

                            <tbody>
                              {items.map((item) => {

                                const itemReturns = getItemReturns(item.item_id);
                                const totalReturnedQty = getTotalReturnedQty(item.item_id);

                                const itemCancels = getItemCancels(item.item_id);
                                const totalCancelledQty = getTotalCancelledQty(item.item_id);

                                const remainingQty =
                                  Number(item.item_qty)
                                  - Number(totalReturnedQty)
                                  - Number(totalCancelledQty);

                                const orderStatus = GetOrdersStatus(item);


                                return (
                                  <>
                                    <tr
                                      className={`product-row ${Number(item?.item_qty) === Number(totalReturnedQty + totalCancelledQty) || item?.item_status === 6 ? "return-overlay"
                                        : ""
                                        }`}
                                      key={item.order_item_id}
                                    >

                                      <td className="product-col text-left">

                                        <h5 className="product-title">

                                          {item.item_name}
                                          <br />
                                          {item.item_number}
                                          <br />
                                          {
                                            item?.invoice_no &&
                                            <>
                                              <span className="text-dark" style={{ fontWeight: "bold" }}>
                                                {item?.invoice_no && `Invoice No : ${item.invoice_no}`}
                                              </span>
                                              <br />
                                            </>
                                          }

                                          {(() => {
                                            // =========================
                                            // RETURN DATA
                                            // =========================

                                            const rejectedReturnsCount = itemReturns.filter(
                                              (ret) => Number(ret.business_return_status) === 4
                                            ).length;

                                            const latestReturnRequest = [...itemReturns]
                                              ?.sort(
                                                (a, b) =>
                                                  new Date(b.business_return_request_date) -
                                                  new Date(a.business_return_request_date)
                                              )?.[0];

                                            // =========================
                                            // CANCEL DATA
                                            // =========================

                                            const rejectedCancelCount = itemCancels.filter(
                                              (cancel) =>
                                                Number(cancel.business_order_cancel_status) === 2
                                            ).length;

                                            const isCancelApproved = itemCancels.some(
                                              (cancel) =>
                                                Number(cancel.business_order_cancel_status) === 1
                                            );

                                            const latestCancelRequest = [...itemCancels]
                                              ?.sort(
                                                (a, b) =>
                                                  new Date(b.business_order_cancel_request_date) -
                                                  new Date(a.business_order_cancel_request_date)
                                              )?.[0];

                                            const itemStatus = Number(item?.item_status);

                                            // ===================================================
                                            // CANCEL SECTION (Status 0 & 1)
                                            // ===================================================

                                            if ([0, 1].includes(itemStatus)) {

                                              // Pending Cancel Request
                                              if (
                                                latestCancelRequest &&
                                                Number(latestCancelRequest.business_order_cancel_status) === 0
                                              ) {
                                                return (
                                                  <span
                                                    className="badge badge-warning text-white"
                                                    style={{
                                                      padding: "6px 12px",
                                                      fontSize: "12px",
                                                      borderRadius: "20px",
                                                      marginTop: "8px",
                                                      display: "inline-block",
                                                    }}
                                                  >
                                                    Cancel Requested
                                                  </span>
                                                );
                                              }

                                              // Cancel Approved
                                              if (isCancelApproved) {
                                                return null;
                                              }

                                              // Cancel Request Limit Exceeded
                                              if (rejectedCancelCount >= 2) {
                                                return (
                                                  <span
                                                    className="badge badge-danger"
                                                    style={{
                                                      padding: "6px 12px",
                                                      fontSize: "12px",
                                                      borderRadius: "20px",
                                                      marginTop: "8px",
                                                      display: "inline-block",
                                                    }}
                                                  >
                                                    Cancel Request Limit Exceeded
                                                  </span>
                                                );
                                              }

                                              // Show Cancel Button
                                              return (
                                                <button
                                                  style={{
                                                    padding: "0.2em 0.5em",
                                                    fontSize: "1.1rem",
                                                    marginRight: "8px",
                                                  }}
                                                  className="btn btn-danger btn-icon-left btn-rounded btn-sm"
                                                  onClick={() => handleCancelItem(item)}
                                                >
                                                  <i className="fa fa-times"></i> {t("Cancel")}
                                                </button>
                                              );
                                            }

                                            // ===================================================
                                            // FULLY CANCELLED
                                            // ===================================================

                                            if (itemStatus === 6) {
                                              return null;
                                            }

                                            // ===================================================
                                            // RETURN SECTION (Status >= 2)
                                            // ===================================================

                                            if (itemStatus >= 2) {

                                              if (!item?.return_allowed) {
                                                return null;
                                              }

                                              if (
                                                latestReturnRequest &&
                                                Number(latestReturnRequest.business_return_status) === 0
                                              ) {
                                                return (
                                                  <span
                                                    className="badge badge-warning text-white"
                                                    style={{
                                                      padding: "6px 12px",
                                                      fontSize: "12px",
                                                      borderRadius: "20px",
                                                      marginTop: "8px",
                                                      display: "inline-block",
                                                    }}
                                                  >
                                                    Return Requested
                                                  </span>
                                                );
                                              }

                                              // No Remaining Qty
                                              if (Number(remainingQty) <= 0) {
                                                return null;
                                              }

                                              // Return Request Limit Exceeded
                                              if (rejectedReturnsCount >= 2) {
                                                return (
                                                  <span
                                                    className="badge badge-danger"
                                                    style={{
                                                      padding: "6px 12px",
                                                      fontSize: "12px",
                                                      borderRadius: "20px",
                                                      marginTop: "8px",
                                                      display: "inline-block",
                                                    }}
                                                  >
                                                    Return Request Limit Exceeded
                                                  </span>
                                                );
                                              }

                                              // Show Return Button
                                              return (
                                                <button
                                                  style={{
                                                    padding: "0.2em 0.5em",
                                                    fontSize: "1.1rem",
                                                  }}
                                                  className="btn btn-primary btn-icon-left btn-rounded btn-sm"
                                                  onClick={() => openReturnModal(item)}
                                                >
                                                  <i className="fa fa-undo"></i> {t("Return")}
                                                </button>
                                              );
                                            }

                                            return null;
                                          })()}

                                          {/* ========================================= */}
                                          {/* CANCEL HISTORY */}
                                          {/* ========================================= */}

                                          {itemCancels.length > 0 && (
                                            <div
                                              style={{
                                                marginTop: "10px",
                                                border: "1px solid #fed7d7",
                                                background: "#fff5f5",
                                                borderRadius: "8px",
                                                padding: "8px"
                                              }}
                                            >
                                              <div
                                                onClick={() => toggleCancelHistory(item.item_id)}
                                                style={{
                                                  cursor: "pointer",
                                                  display: "flex",
                                                  justifyContent: "space-between",
                                                  alignItems: "center"
                                                }}
                                              >
                                                <span
                                                  style={{
                                                    color: "#c53030",
                                                    fontWeight: "600",
                                                    fontSize: "13px"
                                                  }}
                                                >
                                                  <i className="fa fa-times-circle"></i> Cancel History
                                                </span>

                                                <i
                                                  className={`fa ml-3 ${openCancelHistory[item.item_id]
                                                    ? "fa-chevron-up"
                                                    : "fa-chevron-down"
                                                    }`}
                                                  style={{ color: "#c53030" }}
                                                ></i>
                                              </div>

                                              {openCancelHistory[item.item_id] && (
                                                <div style={{ marginTop: "10px" }}>

                                                  {itemCancels.map((cancel, cIndex) => (
                                                    <div
                                                      key={cIndex}
                                                      style={{
                                                        background: "#fff",
                                                        border: "1px solid #fed7d7",
                                                        borderRadius: "6px",
                                                        padding: "8px",
                                                        marginBottom: "6px",
                                                        fontSize: "12px",
                                                        textAlign: "left"
                                                      }}
                                                    >
                                                      <div>
                                                        <b>
                                                          Request #
                                                          {cancel.business_order_cancel_id}
                                                        </b>
                                                      </div>

                                                      <div>
                                                        Remark :
                                                        {" "}
                                                        {cancel.business_order_cancel_remark || "-"}
                                                      </div>

                                                      <div>
                                                        Status :
                                                        {
                                                          Number(cancel.business_order_cancel_status) === 0
                                                            ? " Pending"
                                                            : Number(cancel.business_order_cancel_status) === 1
                                                              ? " Accepted"
                                                              : Number(cancel.business_order_cancel_status) === 2
                                                                ? " Rejected"
                                                                : "-"
                                                        }
                                                      </div>

                                                    </div>
                                                  ))}

                                                </div>
                                              )}
                                            </div>
                                          )}

                                          {/* ========================================= */}
                                          {/* RETURN HISTORY */}
                                          {/* ========================================= */}
                                          {itemReturns.length > 0 && (
                                            <div
                                              style={{
                                                marginTop: "10px",
                                                border: "1px solid #fecaca",
                                                background: "#fef2f2",
                                                borderRadius: "8px",
                                                padding: "8px"
                                              }}
                                            >
                                              <div
                                                onClick={() => toggleReturnHistory(item.item_id)}
                                                style={{
                                                  cursor: "pointer",
                                                  display: "flex",
                                                  justifyContent: "space-between",
                                                  alignItems: "center"
                                                }}
                                              >
                                                <span
                                                  style={{
                                                    color: "#b91c1c",
                                                    fontWeight: "600",
                                                    fontSize: "13px"
                                                  }}
                                                >
                                                  <i className="fa fa-undo"></i> Return History
                                                </span>

                                                <i
                                                  className={`fa ml-3 ${openReturnHistory[item.item_id]
                                                    ? "fa-chevron-up"
                                                    : "fa-chevron-down"
                                                    }`}
                                                  style={{ color: "#b91c1c" }}
                                                ></i>
                                              </div>

                                              {openReturnHistory[item.item_id] && (
                                                <div style={{ marginTop: "10px" }}>

                                                  {itemReturns.map((ret, rIndex) => (
                                                    <div
                                                      key={rIndex}
                                                      style={{
                                                        background: "#fff",
                                                        border: "1px solid #f3d1d1",
                                                        borderRadius: "6px",
                                                        padding: "8px",
                                                        marginBottom: "6px",
                                                        fontSize: "12px",
                                                        textAlign: "left"
                                                      }}
                                                    >
                                                      <div>
                                                        <b>
                                                          Request #{ret.business_return_id}
                                                        </b>
                                                      </div>

                                                      <div>
                                                        Qty : {ret.business_return_qty}
                                                      </div>

                                                      <div>
                                                        Reason :
                                                        {" "}
                                                        {ret.business_return_item_reason || "-"}
                                                      </div>

                                                      <div>
                                                        Status :
                                                        {
                                                          ret.business_return_status === 0
                                                            ? " Pending"
                                                            : ret.business_return_status === 1
                                                              ? " Accepted"
                                                              : ret.business_return_status === 2
                                                                ? " Received"
                                                                : ret.business_return_status === 3
                                                                  ? " Refund"
                                                                  : ret.business_return_status === 4
                                                                    ? " Rejected"
                                                                    : "-"
                                                        }
                                                      </div>

                                                    </div>
                                                  ))}

                                                </div>
                                              )}
                                            </div>
                                          )}

                                        </h5>

                                      </td>

                                      <td>{item?.item_brand}</td>

                                      <td>
                                        <div className="product-single-qty">
                                          <div className="input-group bootstrap-touchspin bootstrap-touchspin-injected">
                                            <span className="input-group-btn input-group-prepend">
                                              {/* {remainingQty} */}
                                              {new Date() >= new Date("2026-09-01") ? item.item_qty : remainingQty}
                                            </span>
                                          </div>
                                        </div>
                                      </td>

                                      <td>
                                        <span className="subtotal-price">
                                          {item?.item_price}
                                        </span>
                                      </td>


                                      <td className="text-center">
                                        <span className="subtotal-price">
                                          {item?.item_vat_amount}
                                        </span>
                                      </td>

                                      <td className="text-right">
                                        <span className="subtotal-price">
                                          {item?.item_sub_total_excl_vat}
                                        </span>
                                      </td>

                                      <td className="text-end">
                                        <span className={`${orderStatus.className} text-white`}>
                                          {orderStatus.label}
                                        </span>
                                      </td>

                                      <td>
                                        {
                                          item?.item_status === 6 ? (
                                            <span className="badge bg-danger text-white">
                                              Item Cancelled
                                            </span>
                                          ) : item?.item_status === 7 ? (
                                            <span className="badge bg-warning text-dark">
                                              Item Returned
                                            </span>
                                          ) : item?.invoice_no ? (
                                            <Link to={`/MyAccount/Orders/ViewInvoice/${item?.business_order_id}/${item?.invoice_id}/${item?.invoice_no}`}>
                                              <button
                                                className="btn btn-success"
                                                style={{
                                                  padding: "2px 8px",
                                                  fontSize: "11px",
                                                  lineHeight: "1.4",
                                                  borderRadius: "3px",
                                                }}
                                              >
                                                View Invoice
                                              </button>
                                            </Link>
                                          ) : (
                                            <span className="badge bg-danger text-white">
                                              -
                                            </span>
                                          )
                                        }
                                      </td>

                                    </tr>

                                    {item.business_order_cancel_id && (
                                      <CancelStatusCard item={item} />
                                    )}

                                  </>
                                );
                              })}
                            </tbody>

                          </table>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>




            {/* Return Request Modal */}
            {showReturnModal && returnItem && (
              <div className="modal fade show" style={{ display: 'block' }} tabIndex="-1" role="dialog">
                <div className="modal-dialog" role="document">
                  <div className="modal-content">
                    <div className="modal-header">
                      <h5 className="modal-title">{t("Return Request")}</h5>
                      <button type="button" className="close" onClick={closeReturnModal}>
                        <span>&times;</span>
                      </button>
                    </div>
                    <div className="modal-body">
                      {/* Display item details */}
                      <div style={{ marginBottom: "1rem" }}>
                        <strong>{returnItem.item_name}</strong>
                        <p>Available Quantity: {returnItem.item_qty}</p>
                      </div>
                      <div className="form-group">
                        <label>{t("Return Quantity")}</label>
                        <div style={{ display: 'flex', alignItems: 'center' }}>
                          <button
                            className="btn btn-secondary"
                            onClick={decreaseQty}
                            disabled={submitting}
                            style={{ minWidth: "40px" }}
                          >
                            -
                          </button>
                          <input
                            type="text"
                            value={returnQuantity}
                            readOnly
                            style={{
                              textAlign: "center",
                              width: "50px",
                              margin: "0 10px",
                              height: "40px",
                              padding: "0",
                              lineHeight: "40px"
                            }}
                          />
                          <button
                            className="btn btn-secondary"
                            onClick={increaseQty}
                            disabled={submitting}
                            style={{ minWidth: "40px" }}
                          >
                            +
                          </button>
                        </div>
                      </div>
                      <div className="form-group">
                        <label>{t("Reason for Return")}</label>
                        <textarea
                          className="form-control"
                          value={returnReason}
                          onChange={(e) => setReturnReason(e.target.value)}
                          disabled={submitting}
                        ></textarea>
                      </div>
                    </div>
                    <div className="modal-footer">
                      <button type="button" className="btn btn-secondary" disabled={submitting} onClick={closeReturnModal}>{t("Cancel")}</button>
                      <button type="button" className="btn btn-primary" disabled={submitting} onClick={handleRequestReturn}>
                        {submitting ? (<span><i className="fa fa-spinner fa-spin"></i> {t("Submitting...")}</span>) : t("Request for Return")}
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            )}
          </main >
      }
    </>
  );

}

export default OrderDetails;